module.exports = __webpack_public_path__ + "static/img/ts1.de6ba2f3.png";